import { TituloReceberFilter } from './titulo-receber-filter';

export class TituloReceberFilterStorage {
    filter: TituloReceberFilter;
    filterValues: Map<string, any>;

    constructor(filter: TituloReceberFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
